import { handleGenericApiError } from "app/api/error";
import PartnerRequests from "app/api/partner";
import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_PARTNERS = "partner:ACTION_SAVE_PARTNERS";
export const ACTION_SAVE_PARTNER = "partner:ACTION_SAVE_PARTNER";
export const ACTION_CLEAR_SELECTED_PARTNER =
  "partner:ACTION_CLEAR_SELECTED_PARTNER";

export const fetchPartners = callback => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await PartnerRequests.fetchPartners();
    dispatch({ type: ACTION_SAVE_PARTNERS, payload: data });
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
export const fetchPartnerById = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await PartnerRequests.fetchPartnerById(id);
    dispatch({ type: ACTION_SAVE_PARTNER, payload: data });
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const createPartner = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await PartnerRequests.createPartner(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const updatePartner = (id, data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await PartnerRequests.updatePartner(id, data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const disablePartner = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await PartnerRequests.disablePartner(id);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const deletePartner = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await PartnerRequests.deletePartner(id);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const togglePartner = id => async dispatch => {
  dispatch(addLoading());
  try {
    await PartnerRequests.togglePartner(id);
    const data = await PartnerRequests.fetchPartners();
    dispatch({ type: ACTION_SAVE_PARTNERS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const clearSelectedPartner = () => async dispatch => {
  dispatch({ type: ACTION_CLEAR_SELECTED_PARTNER });
};
